import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import HomeStoryDetailView from "../../browse-stories/HomeStoryDetailView";
import { useHomeStoryDetail } from "../../browse-stories/useHomeStoryDetail";
import ReadStorySeoHead from "../../components/ReadStorySeoHead";

/** Full story detail for `/read-story/:storyId` (landing carousel). */
export default function CarouselStoryPage() {
    const { storyId } = useParams();
    const location = useLocation();
    const storyIdFromPath = useMemo(() => {
        const m = location.pathname.match(/\/read-story\/([^/]+)\/?$/);
        const id = m?.[1];
        return typeof id === "string" ? id.trim() : "";
    }, [location.pathname]);

    const featuredStoryId =
        typeof storyId === "string" && storyId.trim() !== ""
            ? storyId.trim()
            : storyIdFromPath || undefined;

    const { row, loading, detailLoading, error, contentLanguage } =
        useHomeStoryDetail(featuredStoryId);

    return (
        <Box sx={{ p: { xs: 1.5, sm: 2 }, maxWidth: 1400, mx: "auto" }}>
            <ReadStorySeoHead
                storyId={featuredStoryId}
                row={row}
                contentLanguage={contentLanguage}
                loading={loading}
                error={error}
            />
            <HomeStoryDetailView
                row={row}
                loading={loading}
                detailLoading={detailLoading}
                error={error}
                contentLanguage={contentLanguage}
            />
        </Box>
    );
}
